module.exports = __webpack_public_path__ + "img/pc_main_bg.1c2a25f.webp";